 

export function pickRandomCalendlyLink(data) {
  let randomNum = Math.random() * 100;
  for (const obj of data) {
    randomNum -= obj.percentage;
    if (randomNum <= 0) {
      return obj.calendly_link;
    }
  }

  // This line should never be reached, but if it does, return the last id
  return data[data.length - 1].calendlyLink;
}